import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Typography } from "@material-ui/core";
import Box from "../../../../../../../../ui/Box";
import SquareButton from "../../../../../../../../ui/SquareButton";
import Button from "../../../../../../../../ui/Button";
import {FileIcon} from "../../../../../../../../ui/FileIcon";

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
  reload,
  returnBack,
  programFile
}) => {
  const classes = useStyles();
  let baseUrl = '/work/api/file/';

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={reload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>

        <div className={classes.topBarRight}>
          {(programFile && programFile.fileId) ?
         <Button
           href={`${baseUrl}${programFile.fileId}?download=true`}
           color="gray"
           //startIcon={programFile.mimeType && <FileIcon mimeType={programFile.mimeType}/>}
           >
           Скачать
         </Button>
         : <Typography style={{marginTop: 8}} variant="caption" color="textSecondary">Файл программы не найден</Typography>}
       </div>

      </div>
    </Box>
  );
};

export default withRouter(TopBar);
